module.exports = __webpack_public_path__ + "img/background.adefcbc6.svg";